import { FC } from 'react';
import { useSelector } from 'react-redux';
import { installationSelectors } from '../../redux/slices/InstallationSlice';
import { integrationTypes } from '../../static/constants';
import { ShopifyValidator } from './Shopify/ShopifyValidator';

export interface IOrganisationValidatorProps {
    setIsInvalidOrg: (isValidOrg: boolean) => void;
    setIsValidatingOrg: (isValidatingOrg: boolean) => void;
}

const integrationOrgValidators = new Map();
integrationOrgValidators.set(integrationTypes.SHOPIFY, ShopifyValidator);

const OrganisationValidator: FC<IOrganisationValidatorProps> = ({ setIsInvalidOrg, setIsValidatingOrg }) => {
    const installation = useSelector(installationSelectors.installation);
    const OrgValidator = integrationOrgValidators.get(installation.integrationType);

    return <OrgValidator setIsInvalidOrg={setIsInvalidOrg} setIsValidatingOrg={setIsValidatingOrg} />;
};

export default OrganisationValidator;
